<script>
import { Line } from 'vue-chartjs';

export default {
    extends: Line,
    props: {
        best: [Number, String],
        worst: [Number, String],
        average: [Number, String],
        difference: [Number, String],
        actual: [Number, String],
    },
    computed: {
        data(vm = this) {
            return {
                labels: ['Valores'],
                datasets: [
                    {
                        label: 'Best',
                        borderColor: '#5ea218',
                        data: [this.best, this.best],
                        type: 'line',
                        fill: false,
                        pointRadius: 0,
                        pointHoverRadius: 0,
                    },
                    {
                        label: 'Worst',
                        borderColor: '#fd2e01',
                        data: [this.worst, this.worst],
                        type: 'line',
                        fill: false,
                        pointRadius: 0,
                        pointHoverRadius: 0,
                    },
                    {
                        label: 'Average',
                        borderColor: '#faa500',
                        data: [this.average, this.average],
                        type: 'line',
                        fill: false,
                        pointRadius: 0,
                        pointHoverRadius: 0,
                    },
                    {
                        label: 'Actual',
                        backgroundColor: '#0f111a',
                        data: [this.actual],
                        type: 'bar',
                        stack: 'Stack 1',
                        barPercentage: 0.5,
                    },
                    {
                        label: 'Difference',
                        backgroundColor: '#ccff99',
                        data: [this.actual / 2],
                        type: 'bar',
                        stack: 'Stack 1',
                        barPercentage: 0.5,
                        differenceValue: this.difference,
                    },
                ],
            }
        },
        options(vm = this) {
            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    xAxes:[{
                        display: false,
                    }],
                    yAxes:[{
                        display: false,
                    }]
                },
                legend: {
                    display: false,
                },
                tooltips: {
                    enabled: false,
                    intersect: false,
                },
                hover: {
                    animationDuration: 0
                },
                animation: {
                    onComplete: function () {
                        let chartInstance = this.chart;
                        let ctx = chartInstance.ctx;
                        chartInstance.data.datasets.forEach((dataset, i) => {
                            if (dataset.type === 'bar') {
                                let meta = chartInstance.controller.getDatasetMeta(i)
                                meta.data.forEach(function (bar, index) {
                                    ctx.save()
                                    ctx.font = '22px Arial'
                                    ctx.textAlign = "center"
                                    ctx.fillStyle = i === 4 ? 'black' : 'white'
                                    let barY = bar._model.y
                                    let barHeight = bar._model.base - barY
                                    let textHeight = parseInt(ctx.font, 10)
                                    let yPos = barY + (barHeight / 2) + (textHeight / 2)
                                    let text = i === 4 ? `${dataset.differenceValue}%` : dataset.data[index]
                                    ctx.fillText(text, bar._model.x, yPos)
                                    ctx.restore()
                                })
                            }
                        })
                    }
                },
            }
        }
    },
    mounted() {
        const vm = this
        vm.initChart()
    },
    methods: {
        initChart() {
            const vm = this

            vm.addPlugin({
                afterUpdate: (chart) => {
                    const ctx = chart.ctx
                    chart.config.data.datasets.forEach(dataset => {
                        if (dataset.type === 'bar') {
                            const bar = chart.scales['x-axis-0']
                            for (let key in dataset._meta) {
                                for (let i = 0; i < dataset._meta[key].data.length; i++) {
                                    let model = dataset._meta[key].data[i]._model
                                    model.x = (bar.width / 2) + bar.left
                                }
                            }
                        }
                    })
                },
            })

            vm.renderChart(vm.data , vm.options)
        }
    },
    watch: {
        data() {
            const vm = this
            vm.initChart()
        },
        options() {
            const vm = this
            vm.initChart()
        }
    }
};
</script>